import { render, staticRenderFns } from "./CandidateInterview.vue?vue&type=template&id=2c1f4ce7&scoped=true"
import script from "./CandidateInterview.vue?vue&type=script&lang=js"
export * from "./CandidateInterview.vue?vue&type=script&lang=js"
import style0 from "./CandidateInterview.vue?vue&type=style&index=0&id=2c1f4ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f4ce7",
  null
  
)

export default component.exports